import React, { useEffect } from 'react';
import { IoMdArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import classes from "../home/css/Backbutton.module.css";
import Line from "./Line";

const BackButton = ({ url, className, children }) => {
  const navigate = useNavigate();

  const goBack = () => {
    // Save current scroll before navigating
    sessionStorage.setItem("scroll-back", window.scrollY.toString());

    if (url) {
      navigate(url);
    } else {
      navigate(-1);
    }
  };

  // Restore scroll if saved
  useEffect(() => {
    const saved = sessionStorage.getItem("scroll-back");
    if (saved) {
      setTimeout(() => {
        window.scrollTo(0, parseInt(saved, 10));
        sessionStorage.removeItem("scroll-back");
      }, 0);
    }
  }, []);

  return (
    <Line type="bottom-line" className={className}>
      <button onClick={goBack} className={classes.button}>
        <IoMdArrowRoundBack /> Back
      </button>
      {children}
    </Line>
  );
};

export default BackButton;
